import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductDialog({ product, onClose }) {
  const { addItem } = useCart();
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    setSelected(0);
  }, [product]);

  if (!product) return null;
  const size = product.sizes?.[selected];

  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl p-0 overflow-hidden bg-cream border-line gap-0 sm:rounded-xl">
        <DialogTitle className="sr-only">{product.name}</DialogTitle>
        <DialogDescription className="sr-only">{product.description}</DialogDescription>
        <div className="grid md:grid-cols-2">
          <div className="bg-sand aspect-square md:aspect-auto md:h-full">
            <img src={product.images?.[0]} alt={product.name} className="w-full h-full object-cover" />
          </div>
          <div className="p-8 lg:p-10 flex flex-col">
            <p className="text-xs uppercase tracking-[0.2em] text-clay font-medium mb-3">{product.category}</p>
            <h2 className="font-serif text-3xl lg:text-4xl text-ink leading-tight mb-4" data-testid="dialog-product-name">
              {product.name}
            </h2>
            <p className="text-stone font-light leading-relaxed mb-8">{product.description}</p>

            <p className="text-xs uppercase tracking-[0.2em] text-stone mb-3">Изберете размер</p>
            <div className="flex flex-wrap gap-3 mb-8">
              {product.sizes?.map((s, idx) => (
                <button
                  key={s.label}
                  onClick={() => setSelected(idx)}
                  className={`px-5 py-2.5 rounded-full text-sm border transition-colors duration-300 ${
                    selected === idx
                      ? "bg-ink text-cream border-ink"
                      : "bg-transparent text-ink border-line hover:border-clay"
                  }`}
                  data-testid={`size-option-${idx}`}
                >
                  {s.label}
                  {s.dimensions ? <span className="opacity-60 ml-1">· {s.dimensions}</span> : null}
                </button>
              ))}
            </div>

            <div className="mt-auto flex items-center justify-between border-t border-line pt-6">
              <span className="font-serif text-3xl text-ink" data-testid="dialog-price">
                {size?.price} лв
              </span>
              <button
                onClick={() => {
                  addItem(product, size);
                  toast.success(`${product.name} (${size.label}) е добавен в количката`);
                  onClose();
                }}
                className="bg-clay text-cream px-8 py-3.5 rounded-full text-sm font-medium hover:bg-claydark transition-colors duration-300"
                data-testid="add-to-cart-button"
              >
                Добави в количката
              </button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
